import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';
import { ErrorDetails } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';

export class DeleteRecurringTripCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IDeleteRecurringTripCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'carriers/{carrierId}/recurringTrip/{recurringId}/delete';

  public override setParameters(parameters: IDeleteRecurringTripCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{recurringId}',
      parameters.recurringId.toString()
    );
    this._commandUrl += `?reasonToCancel=${encodeURIComponent(parameters.reasonToCancel)}`;
    this._commandBody = parameters;
  }
}

export interface IDeleteRecurringTripCommandParameters extends ICommandParameters {
  carrierId: number;
  recurringId: number;
  reasonToCancel: string;
  userId: number;
}
